
import React, { useRef } from 'react'
import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom"
import { formatDate } from "../../utils/Formatteddate"
import { formatLikes } from "../../utils/FomattedLike"
import { useDispatch } from "react-redux";
import { ModalAction } from "../../Store/Modal-Slice";
import { ShortAddress } from '../../utils/Address';
import MainImageSkeleton from '../Skeleton/MainImageSkeleton';
import useImageLoader from '../../Hooks/useImageLoader';
import ImageDescription from '../MainImageComponent/ImageDescription';
import { AES } from 'crypto-js';
import amplitude from 'amplitude-js';
import { useSelector } from 'react-redux';
import { followUser } from '../../utils/API/FollowApi';
import { performVote } from '../../utils/API/UpVoteApi';
import { LightBoxAction } from '../../Store/LightboxSlice';
import { SocketAction } from '../../Store/SocketSlice';
import sendCongratulations from '../../utils/API/CongratApi'
import Rehunted from '../Comments/boostbtnsvg/Rehunted.jsx';
import Rehunt from '../Comments/boostbtnsvg/Rehunt.jsx';
import Expired from '../Comments/boostbtnsvg/Expired.jsx';
import { PayWallAction } from '../../Store/PayWallSlice.js';
import { bootApi } from '../../utils/API/PhotoListApi'
import FeedMeta from './FeedMeta.js';
import { addTrackedId } from '../../Store/PhotoTrackingSlice.js';


const ImageContainer = (props) => {

    const [upDownvote, setupDownvote] = useState(props.voted)
    const [votebtnactive, setvotebtnactive] = useState(props.voted || false)
    const [TotalVote, setTotalVote] = useState(props.TotalVotes)
    const [follow, setfollow] = useState(props.is_follow)
    const [IsCongratulate, setIsCongratulate] = useState(props.is_congrat)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [BoostState, setBoostState] = useState(props?.boostedWeeklyPhoto)
    const [IsLoading, setIsLoading] = useState(false);
    const [ExpirError, setExpirError] = useState('');
    const [hasBeenTracked, setHasBeenTracked] = useState(false);
    let dispatch = useDispatch()

    // ImageLoaded hook 
    let isImageLoaded = useImageLoader(props.img);





    // Track photo views 
    const containerRef = useRef(null);

    const trackedIds = useSelector(state => state.photoTracking.trackedIds);
    const trackedIdsSet = new Set(trackedIds);
    useEffect(() => {
        if (!props.isLoggedIn || !props.scheduleGlobalPhotoViews || hasBeenTracked) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const photoId = props.postId;
                        // Check if photoId is NOT already tracked
                        if (!trackedIdsSet.has(photoId)) {
                            // Dispatch to Redux to store the tracked ID
                            dispatch(addTrackedId(photoId));

                            const photoWithStatus = {
                                photoId: photoId,
                                status: props.boostedWeeklyPhoto || ''
                            };
                            // Add to buffer
                            props.globalPhotoViewBuffer.push(photoWithStatus);
                            props.scheduleGlobalPhotoViews();
                            setHasBeenTracked(true);
                        }
                    }
                });
            },
            {
                root: null,
                threshold: 0.5, // 50% visible
            }
        );

        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => {
            if (containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, [props.isLoggedIn, props.postId, props.globalAlreadyTrackedIds, props.globalPhotoViewBuffer, hasBeenTracked]);






    let address = ShortAddress(props.Userlocation, 16);

    // formatDate function 
    const formattedDate = formatDate(props.postedDate);

    //// Like////

    const formattedLikes = formatLikes(TotalVote);

    // < --------Socket ------->
    let ReloadNotificationFn = useSelector(state => state.Socket.ReloadNotificationSenderFn)

    let SendNotificationFn = () => {
        dispatch(SocketAction.setSocketReceiverUserID(props.Userid))
        dispatch(SocketAction.setReloadNotificationSenderFn(!ReloadNotificationFn))
    }
    // <-------------------------------------------->

    let LightboxHandler = (event) => {
        event.preventDefault();
        dispatch(LightBoxAction.setLightBoxActiveImgId(props.postId))
        dispatch(ModalAction.setisLightboxModalOpen(true))
        amplitude.getInstance().logEvent('Expand Photo')
    }

    let navigate = useNavigate();

    let OtheruserProfileNavigateHandler = (event) => {
        event.preventDefault();

        if (props.loginUserid == props.Userid) {
            navigate("/profile");
        } else {
            let userData = {
                PhotoID: props.postId,
                UserID: props.Userid,
            }
            const secretKey = process.env.REACT_APP_SECRET_KEY;
            const encryptedUserData = AES.encrypt(JSON.stringify(userData), secretKey).toString();
            navigate(`/otherusers-profile?userdata=${encodeURIComponent(encryptedUserData)}`);
        }

        window.scrollTo(0, 0)
    }

    let MainImgHandler = () => {
        dispatch(ModalAction.setPopupModalMessage({
            "joinModalHeading": "",
            "popupHeading": "You’re In.",
            "popupMessage": "Next, upvote the photo you were looking at. Give it a chance to be featured in our Tuesday email!",
            photoID: props.postId,
            userID: props.Userid,
        }))
        dispatch(ModalAction.setJoinNowModalState(true))
    }

    ////

    let UpdateTheMianFeedpage = useSelector((state) => state.LightBox.UpdateTheMianFeedpage);


    useEffect(() => {

        if (UpdateTheMianFeedpage?.photoID !== props.postId) {
            return
        } else {


            if (UpdateTheMianFeedpage.TotalVote !== TotalVote) {
                setTotalVote(UpdateTheMianFeedpage.TotalVote)
                setvotebtnactive(!votebtnactive)
                setupDownvote(!upDownvote)
            }
            setfollow(UpdateTheMianFeedpage?.Follow)

        }


    }, [UpdateTheMianFeedpage]);


    useEffect(() => {
        setupDownvote(props.voted || false);
        setvotebtnactive(props.voted || false);
    }, [props.voted]);


    let voteHandler = async () => {


        setvotebtnactive(!votebtnactive)
        setupDownvote(!upDownvote)

        let up_or_down_vote;
        if (upDownvote) {
            up_or_down_vote = "remove"
            setTotalVote((TotalVote * 1) - 1)
            dispatch(LightBoxAction.setUpdateTheMianFeedpage({ TotalVote: (TotalVote * 1) - 1, Follow: follow, photoID: props.postId, votebtnactive: !votebtnactive }))
        } else {
            setTotalVote((TotalVote * 1) + 1)
            dispatch(LightBoxAction.setUpdateTheMianFeedpage({ TotalVote: (TotalVote * 1) + 1, Follow: follow, photoID: props.postId, votebtnactive: !votebtnactive }))
            up_or_down_vote = "add"
            amplitude.getInstance().setUserId(props.loginUserid);
            amplitude.getInstance().logEvent('Upvote');
            SendNotificationFn()
        }
        try {

            const response = await performVote(props.postId, up_or_down_vote, props.usertoken);


            // setTotalVote(response.data.data.voteCount)

        } catch (error) {

        }

    }


    // <------------------------->
    let Upvotebtnstate = useSelector(state => state.Modal.PopupModalMessage)

    useEffect(() => {

        if (props.postId && Upvotebtnstate.photoID == props.postId && !props.voted) {
            voteHandler()
            dispatch(ModalAction.setPopupModalMessage({

                photoID: '',
                userID: '',
            }))
        }
    }, [])
    // <-------------------------->



    let FollowHandler = async (event) => {
        event.preventDefault();
        setfollow(!follow)

        if (!follow) {
            SendNotificationFn()
        }

        dispatch(LightBoxAction.setUpdateTheMianFeedpage({ TotalVote, Follow: !follow, photoID: props.postId }))
        try {
            const response = await followUser(props.Userid, !follow, props.usertoken, props.loginUserid, SendNotificationFn);
        } catch (error) {
        }
    }


    let CongratulationssHandler = async (event) => {
        event.preventDefault();
        setIsCongratulate(!IsCongratulate);

        try {
            const response = await sendCongratulations(props.usertoken, props.Userid, props.postId, IsCongratulate, props.loginUserid);
            SendNotificationFn()
        } catch (error) {

        }
    }


    let SharePhotobtnHandler = () => {
        dispatch(ModalAction.setSharePhotoModalState(true))

        dispatch(ModalAction.setShareModalPhotoInfo(
            props.loginUserid !== props.Userid ?
                {
                    "path": props.img,
                    "id": props.postId,
                    "shareType": "Share Other User Photo"
                }
                :
                {
                    "path": props.img,
                    "id": props.postId,
                    "shareType": ""
                }
        ))
    }


    let PayWalltitleObject = () => {
        dispatch(PayWallAction.setPayWallModalTitleObj({ Title: "Upgrade to have full control over when your photos get hunted.", Subtitle: 'Become a Participating Member to schedule your hunted photos, manage them and post them exactly how and when you want.' }))
        dispatch(ModalAction.setisPayWallOpen(true))
    }



    const BoostApiHandler = async () => {
        const dateOnly = props.postedDate.split(' ')[0];
        setIsLoading(true)
        setExpirError('')
        try {
            const response = await bootApi(props.postId, dateOnly);
            amplitude.getInstance().logEvent("Rehunt");

            localStorage.setItem('RehuntedPost', JSON.stringify(props.PostFullData))
            setBoostState("Rehunted")
            setIsLoading(false)
            setIsModalOpen(false)
        } catch (error) {
            setIsLoading(false)
            setExpirError(error?.response?.data?.message)
            console.error(error);
        }
    }

    const BoostSvgs = {
        "Rehunt": <Rehunt />,
        "Rehunted": <Rehunted />,
        "Rehunted_Before": <Rehunted />,
        "Out of Time": <Expired />
    }

    return (
        <>
            <div className="feed_item  style-2" ref={containerRef}>
                <div className={`feed_item_inner ${props.isLoggedIn && isImageLoaded ? 'logged-in' : ''}`}>
                    <a onClick={props.isLoggedIn ? LightboxHandler : MainImgHandler} style={{ width: '100%' }} className={`feed_img ${props.isLoggedIn && isImageLoaded ? 'logged-in' : ''}`}>
                        {!isImageLoaded ? (
                            <MainImageSkeleton />
                        ) : (
                            <img
                                className='main-img'
                                src={props.img}
                                alt="img"
                            />)}
                    </a>

                    {/* feed_hover_text */}


                    <FeedMeta
                        props={props}
                        OtheruserProfileNavigateHandler={OtheruserProfileNavigateHandler}
                        MainImgHandler={MainImgHandler}
                        voteHandler={voteHandler}
                        SharePhotobtnHandler={SharePhotobtnHandler}
                        FollowHandler={FollowHandler}
                        CongratulationssHandler={CongratulationssHandler}
                        BoostState={BoostState}
                        BoostSvgs={BoostSvgs}
                        setIsModalOpen={setIsModalOpen}
                        address={address}
                        formattedDate={formattedDate}
                        formattedLikes={formattedLikes}
                        votebtnactive={votebtnactive}
                        follow={follow}
                        IsCongratulate={IsCongratulate}
                        comingUp={props.comingUp}
                        UserPaymentStatus={props.UserPaymentStatus}


                    />


                </div>
                {<ImageDescription
                    displayUserSocailPhoto={props.displaySocailUserPhoto}
                    usertoken={props.usertoken}
                    Name={props.display_name}
                    loginUserid={props.loginUserid}
                    isLoggedIn={props.isLoggedIn}


                    img={props.img}
                    postId={props.postId}
                    First1Comments={props.First1Comments}
                    TotalComments={props.TotalComments}
                    show={props.show}
                    sharebtn={props.sharebtn}
                    description={props.description}
                    feedback={props.feedback}
                    metadata={props.metadata}
                    Userid={props.Userid}
                    UserPaymentStatus={props.UserPaymentStatus}
                />}
            </div>




            {isModalOpen && <>
                <div className="backdrop" />
                <div className="modal fade bph-modal show" id="QueuedPhotoModal" tabIndex={-1} aria-labelledby="sharePhotoModal" aria-hidden="true" style={{ display: "block", marginTop: "30px" }}>
                    <div className="modal-dialog modal-dialog-centered modalAnimation">
                        <div className="modal-content">
                            <div className="modal-body">
                                {/* First */}
                                <div className="onboarding_modal photoUpload_modal photoQueued">
                                    <div className="modal_inner">
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setIsModalOpen(false)} />
                                        {/* logo */}
                                        <div className="modal_logo d-none d-md-inline-flex ">
                                            <img src="./assets/img/logo/modal-logo.png" alt />
                                        </div>
                                        {/* content */}
                                        <div className="modal_content photoQueue_content">
                                            <div className="modal_title">
                                                <h3 className="title"><img src="./assets/img/icons/info.svg" alt />{BoostState == "Out of Time" ? "Oops. Too Late. " : " Rehunt Your Photo"}</h3>
                                                <p className="desc">{BoostState == "Out of Time" ? "Rehunt can only be used during the week your photo is being hunted." : (props.UserPaymentStatus ? "Push your photo back to the top—for members who haven’t seen it or didn’t upvote." : "Rehunt gives your photo a once-a-week boost to the top of the feed—for members who didn’t see it or didn’t upvote.")}</p>
                                                <br />
                                                < p className="desc">{BoostState == "Out of Time" ? "That window’s closed for this one—make sure to use it on your next hunted photo!" : (props.UserPaymentStatus ? "As a Pro member, you get a smart, once-a-week boost to help your photo reach more people—and get the love it deserves." : "It’s part of our Pro membership, designed to get more eyes on—and love for—your best shots.")}
                                                </p>
                                                {ExpirError && <p style={{ color: "red", marginBottom: "-20px" }} className="desc">"{ExpirError}"</p>}
                                                <button
                                                    style={{ marginTop: "22px" }}
                                                    className="btn"
                                                    type="submit"
                                                    onClick={() => {
                                                        if (BoostState !== "Out of Time") {
                                                            props.UserPaymentStatus ? BoostApiHandler() : PayWalltitleObject();
                                                        } else {
                                                            setIsModalOpen(false)
                                                        }
                                                    }}

                                                >
                                                    {BoostState !== "Out of Time" ? (props.UserPaymentStatus ? (
                                                        IsLoading ? <span className="loader"></span> : "Rehunt My Photo"
                                                    ) : (
                                                        "Go Pro to Get It"
                                                    )) : "Ok"}
                                                </button>
                                                {BoostState !== "Out of Time" && <span className="btn_note" style={{ cursor: 'pointer' }} onClick={() => setIsModalOpen(false)}>{"Not for this photo"}</span>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>}

        </>
    )
}

export default ImageContainer